export default __webpack_public_path__ + "static/studio-slider-21-e160ccd62d52840b8bf856657dee2c30.png";